import React, { ReactNode } from 'react'

interface ILockChild {
  shouldBeLocked: boolean
  children: ReactNode
}

/**
 * @deprecated Stop using this component. Use the `disabled` prop of `<fieldset>` inside a `<form>`.
 * @example
 *
 * // Bad - Results in a nested <fieldset>
 * <LockChild shouldBeLocked={true}>
 *   <form>
 *     <fieldset>
 *       ...
 *     </fieldset>
 *   </form>
 * </LockChild>
 *
 * // Good - Fieldset should be inside the <form> element.
 * <form>
 *   <fieldset disabled={shouldBeLocked}>
 *     ...
 *   </fieldsed>
 * </form>
 */
function LockChild({ shouldBeLocked, children }: ILockChild) {
  return (
    <>
      {shouldBeLocked ? (
        <fieldset
          disabled
          className='opacity-50 bg-slate-50 pointer-events-none w-full'
        >
          {children}
        </fieldset>
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default LockChild
